import reportTypes from "~constants/report_types.json";
import reportLabels from "~constants/labels.json";
import reportSections from "~constants/ui_group_titles.json";
import translatedLabels from "~constants/translate_prop_to_label.json"
import parsedValues from "~constants/parsed_values.json";
import user from "~constants/user.json";
import relacoesVinculos from "~constants/relacoes_vinculos.json";
import { AiModelOption } from "~/types/global";

export const RELACOES_VINCULOS = relacoesVinculos;
export const REPORT_CONSTANTS = reportTypes;
export const REPORT_LABELS = reportLabels;
export const REPORT_SECTIONS = reportSections;
export const USER_CONSTANTS = user;
export const USER_INVITE_CONSTANTS = user.user_invite;
export const TRANSLATED_LABELS = translatedLabels;
export const PARSED_VALUES = parsedValues;
export const REPORT_TYPES = Object.entries(reportTypes.types);
export const NON_ENCRYPTED_KEYS = [
  REPORT_CONSTANTS.new_report.report_type,
  REPORT_CONSTANTS.new_report.organization_id,
  REPORT_CONSTANTS.new_report.user_id,
  REPORT_CONSTANTS.new_report.report_id,
  REPORT_CONSTANTS.new_report.subject_age,
  REPORT_CONSTANTS.new_report.creation_at,
  REPORT_CONSTANTS.new_report.modified_at,
  REPORT_CONSTANTS.summary.summary_id,
  REPORT_CONSTANTS.summary.report_id,
  REPORT_CONSTANTS.summary.summary_status,
  "has_summary",
  "summary_generating",
];

export const verifierPhrase = "youshallnotpass";

export const tanstackQueryConfig = {
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
};

export const SK_STORAGE_DURATION = [
  { value: "none", label: "Não armazenar" },
  // { value: "1m", label: "1 minuto (teste)" },
  { value: "15m", label: "15 minutos" },
  { value: "30m", label: "30 minutos" },
  { value: "1h", label: "1 hora" },
  { value: "session", label: "Armazenar senha enquanto estiver logado(a)" } // "Armazenar a senha enquanto a sessão estiver ativa"
]

export const COLUMNS_BREAKPOINTS = {
  346: 1, // 282 + 64 (padding)
  628: 2, // (282 * 2) + 20 + 64
  930: 3, // (282 * 3) + (20 * 2) + 64
  1232: 4, // (282 * 4) + (20 * 3) + 64
  1534: 5, // (282 * 5) + (20 * 4) + 64
  1836: 6, // (282 * 6) + (20 * 5) + 64
  2138: 7, // (282 * 7) + (20 * 6) + 64
  2440: 8, // (282 * 8) + (20 * 7) + 64
  2742: 9, // (282 * 9) + (20 * 8) + 64
};

export const MAX_REPORT_DETAILS_CONTAINER_HEIGHT = "max-h-[calc(100vh-180px)]"
export const MAX_TAB_CONTAINER_HEIGHT = "max-h-[calc(100vh-250px)]"
export const MAX_REPORT_LIST_CONTAINER_HEIGHT = "max-h-[calc(100vh-224px)]"

export const USER_LOGS_REPORT_TYPE_OPTIONS = [
  { label: 'TODOS OS TIPOS', value: 'TODOS OS TIPOS' },
  { label: 'CPF', value: 'cpf' },
  { label: 'CNPJ', value: 'cnpj' },
  { label: 'EMAIL', value: 'email' },
  { label: 'TELEFONE', value: 'telefone' },
  { label: 'RELAÇÕES', value: 'relacoes' },
  { label: 'COMBINADO', value: 'combinado' },
  { label: 'LOTE', value: 'lote' },
];

export const USER_LOGS_REPORT_STATUS_OPTIONS = [
  { label: 'TODOS OS STATUS', value: 'TODOS OS STATUS' },
  { label: 'SUCESSO', value: 'success' },
  { label: 'ERRO', value: 'error' },
  { label: 'PENDENTE', value: 'pending' },
  { label: 'EXCLUÍDO', value: 'deleted' },
];

export const USER_LOGS_DEFAULT_REPORT_TYPE = 'TODOS OS TIPOS';
export const USER_LOGS_DEFAULT_REPORT_STATUS = 'TODOS OS STATUS';
export const REPORT_DEFAULT_CONTAINER_ID = 'report-content';

export const VALID_PHONE_DDDS = ['11', '12', '13', '14', '15', '16', '17', '18', '19', '21', '22', '24', '27', '28',
  '31', '32', '33', '34', '35', '37', '38', '41', '42', '43', '44', '45', '46', '47', '48', '49',
  '51', '53', '54', '55', '61', '62', '63', '64', '65', '66', '67', '68', '69', '71', '73', '74',
  '75', '77', '79', '81', '82', '83', '84', '85', '86', '87', '88', '89', '91', '92', '93', '94',
  '95', '96', '97', '98', '99'];

export const CHECK_SESSION_INTERVAL = {
  1: 5000, // 5 segundos
  2: 10000, // 10 segundos
  3: 30000, // 30 segundos
  4: 60000, // 1 minuto
  5: 300000, // 5 minutos
}

// Opções de filtro para convites de usuários
export const USER_INVITES_STATUS_OPTIONS = [
  { label: 'TODOS OS STATUS', value: 'TODOS OS STATUS' },
  { label: 'PENDENTE', value: 'enviado' },
  { label: 'ACEITO', value: 'aceito' },
  { label: 'NEGADO', value: 'negado' },
  { label: 'CANCELADO', value: 'cancelado' },
];

export const USER_INVITES_TYPE_OPTIONS = [
  { label: 'TODOS OS PERFIS', value: 'TODOS OS PERFIS' },
  { label: 'ADMINISTRADOR', value: 'administrador' },
  { label: 'INVESTIGADOR', value: 'investigador' },
];

export const ORG_USERS_STATUS_OPTIONS = [
  { label: 'TODOS OS STATUS', value: 'TODOS OS STATUS' },
  { label: 'ATIVO', value: 'ativo' },
  { label: 'DESVINCULADO', value: 'inativo' },
];

export const ORG_USERS_DEFAULT_STATUS = 'TODOS OS STATUS';

export const USER_INVITES_DEFAULT_STATUS = 'TODOS OS STATUS';
export const USER_INVITES_DEFAULT_TYPE = 'TODOS OS PERFIS';

export const DEFAULT_AI_MODEL_OPTIONS: AiModelOption[] = [
  {
    value: "local",
    label: "Modo Privado",
    subtitle: "Dados tratados no servidor local • Respostas mais simples",
    tooltip: "Processamento em servidor local — os dados não são enviados a provedores externos. Possui menor capacidade de processamento em tarefas complexas.",
  },
  {
    value: "nuvem",
    label: "Modo Nuvem",
    subtitle: "Dados enviados a servidores externos • Mais capacidade e qualidade",
    tooltip: "Processamento em servidores de IA externos — os dados serão enviados ao provedor para gerar respostas mais avançadas.",
  }
] as const;